module.exports = __webpack_public_path__ + "static/media/heart-filled-icon.72a24a00.svg";